export const LIMITE_HISTORIAL = 100;

export const historialNuevo = (presente) => ({ pasado: [], presente, futuro: [] });

// agrupar: el cambio se suma al último paso en lugar de crear uno nuevo
// (tipear un nombre letra por letra se deshace de una vez).
export const registrar = (historial, nuevo, { agrupar = false } = {}) => {
  if (nuevo === historial.presente) return historial;
  if (agrupar) return { ...historial, presente: nuevo, futuro: [] };
  return {
    pasado: [...historial.pasado, historial.presente].slice(-LIMITE_HISTORIAL),
    presente: nuevo,
    futuro: [],
  };
};

export const deshacer = (historial) => {
  if (historial.pasado.length === 0) return historial;
  const anterior = historial.pasado[historial.pasado.length - 1];
  return {
    pasado: historial.pasado.slice(0, -1),
    presente: anterior,
    futuro: [historial.presente, ...historial.futuro],
  };
};

export const rehacer = (historial) => {
  if (historial.futuro.length === 0) return historial;
  const [siguiente, ...resto] = historial.futuro;
  return {
    pasado: [...historial.pasado, historial.presente],
    presente: siguiente,
    futuro: resto,
  };
};
